// Единые токены фирменного стиля ВК-КЛИМАТ.
export const colors = {
  red: "#E30613",
  redDark: "#b80510",
  redSoft: "#fdecec",
  redLight: "#ff5a64",
  ink: "#121212",
  ink2: "#1A1A1A",
  text: "#4b5560",
  muted: "#6b7280",
  border: "#e8eaee",
  bgLight: "#F5F6F8",
  bgPanel: "#F4F5F7",
  white: "#fff",
};

export const font = {
  display: "Oswald, sans-serif",
  body: "'PT Sans', sans-serif",
};

export const maxWidth = 1200;

// Фоновое фото для hero и CTA-форм. Меняйте в одном месте, чтобы сравнивать варианты.
// WebP-версии (лёгкие): /hero-1.webp (блоки на крыше), /hero-2.webp (воздуховоды),
//                        /hero-3.webp (фасад с кондиционерами). JPG-версии тоже есть.
export const heroImage = "/hero-1.webp";
